// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Classes */\n.side-menu-header {\n    border-bottom: 1px solid #dfe2e6;\n}\n\n/* Ids. */\n#side-menu-header-title {\n    margin-top: 20px;\n    font-size: 2rem;\n}\n\n#side-menu-header-logo {\n    width: 6rem;\n    margin-bottom: 30px;\n}", ""]);
// Exports
module.exports = exports;
